import {
  deleteApiNotificationsId,
  getApiNotificationsId,
  postApiNotifications,
  putApiNotificationsId,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const notificationByIdQuery = createQuery({
  handler: getApiNotificationsId,
})

export const notificationCreate = createMutation({
  handler: postApiNotifications,
})

export const notificationUpdate = createMutation({
  handler: putApiNotificationsId,
})

export const notificationDelete = createMutation({
  handler: deleteApiNotificationsId,
})
